import { apiInstance, gql } from "@/services/httpAdapter";
import { errorLogger } from "@Common/helpers/logger";
import { ISystemSettings } from "@Settings/types/Common/model";
import { IMappedPosition } from "@Common/types/positions/api";
import { IMappedPositionInput } from "@Settings/types/PositionMapping/types";
import { GraphqlQueryResponse } from "@/Common/api/types/GraphqlQueryResponse";

type TSelectedSystemSettings = Pick<
	ISystemSettings,
	"_id" | "locationId" | "mappedPositions" | "accountingPositions" | "requiredPositions"
> & {
	mappedPositions: Array<
		Pick<
			IMappedPosition,
			"_id" | "systemPosition" | "payrollPosition" | "drawFrequency" | "isDepartmental" | "chargebackDeductionCodes" | "ptoType"
		>
	>;
	requiredPositions: Array<Pick<IMappedPosition, "_id" | "systemPosition" | "payrollPosition" | "drawFrequency">>;
};

export async function updateSystemSettingsMappedPositions(locationId: string, input: IMappedPositionInput) {
	const query = gql`
		mutation updateSystemSettingsPositions($locationId: String!, $input: SystemSettingsInput) {
			updateSystemSettingsPositions(locationId: $locationId, input: $input) {
				locationId
				mappedPositions {
					_id
					systemPosition
					payrollPosition
					drawFrequency
					isDepartmental
				}
				accountingPositions
				requiredPositions {
					_id
					systemPosition
					payrollPosition
					drawFrequency
				}
			}
		}
	`;

	const variables = {
		locationId,
		input,
	};

	try {
		const response: GraphqlQueryResponse<"updateSystemSettings", TSelectedSystemSettings> = await apiInstance.post("/graphql", {
			query,
			variables,
		});
		return response.data.data?.updateSystemSettings;
	} catch (err) {
		errorLogger(err as Error, {
			function: "updateSystemSettingsMappedPositions",
			message: "Error updating system settings mapped positions",
			variables,
		});
		return null;
	}
}
